import { PureComponent } from "react";

import { POVerifyWorkStatuses } from "types/enum";

import { type StatusTypes } from "commonComponents/utilities/Status/StatusDisplay";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

interface IPurchaseOrderVerifyWorkStatusTagProps {
    status: POVerifyWorkStatuses;
}

const getPurchaseOrderVerifyWorkStatusType = (status: POVerifyWorkStatuses): StatusTypes => {
    switch (status) {
        case POVerifyWorkStatuses.Voided:
            return "danger";
        case POVerifyWorkStatuses.InProgress:
            return "";
        case POVerifyWorkStatuses.WorkCompleted:
            return "success";
        case POVerifyWorkStatuses.Pending:
        case POVerifyWorkStatuses.SubRequestedInspectionAndPayment:
            throw Error("Not yet implemented for this status.");
    }
};

const getPurchaseOrderVerifyWorkStatusText = (status: POVerifyWorkStatuses) => {
    switch (status) {
        case POVerifyWorkStatuses.Voided:
            return "Voided";
        case POVerifyWorkStatuses.InProgress:
            return "Work Incomplete";
        case POVerifyWorkStatuses.WorkCompleted:
            return "Work Complete";
        case POVerifyWorkStatuses.Pending:
        case POVerifyWorkStatuses.SubRequestedInspectionAndPayment:
            throw Error("Not yet implemented for this status.");
    }
};

export class PurchaseOrderVerifyWorkStatusTag extends PureComponent<IPurchaseOrderVerifyWorkStatusTagProps> {
    render() {
        const { status } = this.props;
        return (
            <StatusTagDisplay
                statusType={getPurchaseOrderVerifyWorkStatusType(status)}
                statusText={getPurchaseOrderVerifyWorkStatusText(status)}
            />
        );
    }
}
